import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "search-dropdown"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ais_search_box = _resolveComponent("ais-search-box");
  const _component_router_link = _resolveComponent("router-link");
  const _component_ais_hits = _resolveComponent("ais-hits");
  const _component_ais_index = _resolveComponent("ais-index");
  const _component_ais_refinement_list = _resolveComponent("ais-refinement-list");
  const _component_ais_instant_search = _resolveComponent("ais-instant-search");
  return _openBlock(), _createBlock(_component_ais_instant_search, {
    ref: "searchRef",
    class: "position-relative",
    "search-client": $setup.searchClient,
    "index-name": "faqs"
  }, {
    default: _withCtx(() => [_createVNode(_component_ais_search_box, {
      class: _normalizeClass({
        'border-change-input': $setup.isDropdownVisible
      }),
      onKeyup: $setup.toggleDropdown,
      onFocusout: $setup.dropdownVisible
    }, null, 8, ["class", "onKeyup", "onFocusout"]), $setup.isDropdownVisible ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["overflow-hidden", {
        'border-change': $setup.isDropdownVisible
      }])
    }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_ais_index, {
      "index-name": "faqs"
    }, {
      default: _withCtx(() => [_createVNode(_component_ais_hits, {
        onFocusout: _cache[0] || (_cache[0] = $event => $setup.isDropdownVisible = false)
      }, {
        default: _withCtx(({
          items
        }) => [_createElementVNode("ul", null, [_cache[1] || (_cache[1] = _createElementVNode("li", {
          class: "faq-list"
        }, "FAQ", -1)), items.length !== 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(items, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.objectID
          }, [_createVNode(_component_router_link, {
            to: '/faq/' + item.slug
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 128)) : (_openBlock(), _createElementBlock("li", _hoisted_2, "No FAQ Found"))])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_ais_index, {
      "index-name": "blog_posts"
    }, {
      default: _withCtx(() => [_createVNode(_component_ais_hits, null, {
        default: _withCtx(({
          items
        }) => [_createElementVNode("ul", null, [_cache[2] || (_cache[2] = _createElementVNode("li", {
          class: "blog-list"
        }, "BLOG", -1)), items.length !== 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(items, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.objectID
          }, [_createVNode(_component_router_link, {
            to: '/blogs/' + item.slug
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 128)) : (_openBlock(), _createElementBlock("li", _hoisted_3, "No Blog Found"))])]),
        _: 1
      }), _createVNode(_component_ais_refinement_list, {
        attribute: "categories"
      })]),
      _: 1
    })])], 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["search-client"]);
}